import React from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid
} from "@material-ui/core/";

export default (props) => {

    const listaSituacoes = props.opcoesSituacoes.map((element,i) =>
        <MenuItem key={i} value={element.id}>{element.nome}</MenuItem>
    );

    return (
        <Grid container>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <InputLabel id="select-Situacoes-label">Situações</InputLabel>
                    <Select
                        labelId="select-Situacoes-label"
                        id="select-Situacoes"
                        label="Situacoes"
                        value={props.escolhaSituacao}
                        onChange={props.handlerChangeSituacoes}
                    >
                        {listaSituacoes}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};